// hw-0914-staging-segment-click-shifts-wheel-180px: selecting a Builder
// segment mounts the Segment Settings side pane (SegmentView) as a flex
// sibling of the wheel canvas. WheelComponent is rendered with
// `resize={false}` in SegmentBuilder/index.jsx, so createPie.js never
// recomputes pieOutterRadius/label geometry when that happens — the wheel's
// SVG content is frozen in local coordinates. What actually moves is the
// wheel's own container (`this.parent`) on the PAGE, squeezed left by the
// new sibling. A rim-pill anchored near the wheel's left edge can end up
// entirely (or partially) past the container's visible left edge, reading
// as a clipped/missing label. Pure, dependency-free (createPie.js pulls in
// ESM-only d3 and can't be imported directly by Jest) so this geometry math
// is unit-testable on its own.

/**
 * Given a label group's on-page rect and its container's on-page rect,
 * return the horizontal translate adjustment (added to the group's current
 * transform tx) needed to keep the group fully within the container's
 * left/right bounds. Returns 0 if the group already fits.
 *
 * If the group is wider than the container, the left edge wins (keeps the
 * start of the label visible rather than the end).
 */
export function computeClampDx({
  groupLeft,
  groupRight,
  containerLeft,
  containerRight,
}) {
  const overflowLeft = containerLeft - groupLeft;
  if (overflowLeft > 0) return overflowLeft;

  const overflowRight = groupRight - containerRight;
  if (overflowRight > 0) return -overflowRight;

  return 0;
}

/**
 * Parses a `translate(x,y)` SVG transform attribute value into [x, y]
 * numbers. Returns null if the string doesn't match.
 */
export function parseTranslate(transform) {
  if (!transform) return null;
  const match = /translate\(\s*(-?[\d.]+)\s*,\s*(-?[\d.]+)\s*\)/.exec(
    transform
  );
  if (!match) return null;
  return [parseFloat(match[1]), parseFloat(match[2])];
}
